import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Trash2 } from 'lucide-react';

export function DeleteChallanDialog({ open, onOpenChange, deleteTarget, confirmDelete, deleteLoading }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="delete-challan-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-red-600">
            <Trash2 size={18} />
            Delete Challan
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 mt-2">
          <p className="text-sm text-zinc-700">
            Are you sure you want to delete challan <strong className="font-mono">{deleteTarget?.challan_number}</strong>?
            This will also remove all associated dispatch records. This action cannot be undone.
          </p>
          <div className="flex justify-end gap-3 pt-2 border-t border-zinc-200">
            <Button variant="outline" className="h-9 rounded-sm" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button
              className="h-9 rounded-sm bg-red-600 hover:bg-red-700 text-white"
              onClick={confirmDelete}
              disabled={deleteLoading}
              data-testid="confirm-delete-challan"
            >
              {deleteLoading ? 'Deleting...' : 'Delete'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
